import React, { useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import cl from "./personal.module.css"
import camera from "../../images/camera.png"
import Posts from '../../components/Posts';
import { getAuth, updateProfile, updateEmail, updatePassword, reauthenticateWithCredential, EmailAuthProvider, signInWithCredential } from "firebase/auth";
import axios from 'axios'
import { setUser } from '../../store/slices/userSlice';
import PopUp from '../../components/UI/popUp/popUp';

const PersonalPage = () => {
  const user = useSelector(state => state.user);
  const posts = useSelector(state => state.posts.posts)
  let arrayOfCreatedPosts = useSelector(state => state.user.createdPosts);
  const ref = useRef(null);
  const dispatch = useDispatch();
  const [popUp, setPopUp] = useState(false);

  const { email, name, surname, avatar } = user;
  const [objOfValue, setObjOfValue] = useState({
    name: name,
    surname: surname,
    email: email,
    avatar: avatar,
    password: '',
  });

  const promptForCredentials = () => {
    let psw = prompt('Введите парль для подтверждения', '');
    if (psw.length > 6) {
      return psw
    }
  }
  const updateUserData = async () => {
    let userUpdate = false;
    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      const pass = promptForCredentials();
      const creadential = EmailAuthProvider.credential(email, pass);
      const userCredential = await signInWithCredential(auth, creadential);
    } else {
      const pass = promptForCredentials();
      const creadential = EmailAuthProvider.credential(currentUser.email, pass);
      await reauthenticateWithCredential(currentUser, creadential).then(res => console.log(res)).catch(err => {
        alert('Ошибка авторизации, проверьте введённые данные!')
        console.log(err)
        return;
      });
    }
    let objToChange = {};
    if (objOfValue.name !== name || objOfValue.surname !== surname) {
      objToChange.displayName = `${objOfValue.name} ${objOfValue.surname}`
    }
    if (objOfValue.avatar !== avatar) {
      objToChange.photoURL = objOfValue.avatar
    };

    if (Object.keys(objToChange).length !== 0) {
      await updateProfile(auth.currentUser, objToChange).then(res => console.log('Данные профиля обновлены'));
      window.localStorage.setItem('name', objOfValue.name);
      window.localStorage.setItem('surname', objOfValue.surname);
      window.localStorage.setItem('avatar', objOfValue.avatar);
      userUpdate = true;
    };

    if (objOfValue.email !== email) {
      userUpdate = true;
      updateEmail(auth.currentUser, objOfValue.email).then(console.log('email updated'))
      window.localStorage.setItem('email', objOfValue.email);
    }
    if (objOfValue.password && objOfValue.password.length > 6) {
      updatePassword(auth.currentUser, objOfValue.password).then(res => {
        console.log('Пароль обновлён');
        setObjOfValue({ ...objOfValue, password: '' })
      })
    };
    if (userUpdate) dispatch(setUser(objOfValue));
    setPopUp(true);
  };

  const postsForPersonalPage = posts.filter(post => arrayOfCreatedPosts.includes(post._id));

  function addImage() {
    if (!ref.current.files[0]) return;

    const formData = new FormData();
    formData.append('file', ref.current.files[0])
    formData.append('upload_preset', 'xgwjpon7');
    axios.post('https://api.cloudinary.com/v1_1/saha230904/image/upload', formData)
      .then(res => {
        setObjOfValue({ ...objOfValue, avatar: res.data.secure_url });
      });
  }

  return (
    <>
      <PopUp visible={popUp}>
        <h2 style={{ textAlign: 'center' }}>Данные вашего профиля успешно обновлены</h2>
        <div className="" style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>
          <button name='save' style={{}}
            onClick={e => setPopUp(false)}
          >Отлично</button>
        </div>
      </PopUp>
      <div className='personal post__wrapper'>
        <div className={cl.head}>
          <div className={cl.avatar}>
            <img src={objOfValue.avatar} alt="avatar" className={cl.avatarImg} />
            <input type="file" name='avatar' accept=".jpg, .jpeg, .png, .bmp"
              ref={ref}
              id='avatar'
              className={cl.fileInp}
              onChange={addImage} />
            <label htmlFor="avatar" className={cl.camera} >
              <img src={camera} alt="camera" className={cl.cameraImg} />
            </label>
          </div>
        </div>
        <div className={cl.main}>
          <div className="">
            <h4>Имя</h4>
            <input type="text" defaultValue={name} onChange={e => setObjOfValue({ ...objOfValue, name: e.target.value })} id="personal-name" />
          </div>
          <div className="">
            <h4>Фамилия</h4>
            <input type="text" defaultValue={surname} onChange={e => setObjOfValue({ ...objOfValue, surname: e.target.value })} id="personal-surname" />
          </div>
          <div className="">
            <h4>Email</h4>
            <input type="text" defaultValue={email} onChange={e => setObjOfValue({ ...objOfValue, email: e.target.value })} id="personal-email" />
          </div>
          <div className="">
            <h4>Новый пароль</h4>
            <input type="text" value={objOfValue.password} onChange={e => setObjOfValue({ ...objOfValue, password: e.target.value })} id="personal-password" />
          </div>
        </div>
        <div className="personal__footer">
          <div className={cl.footerBtn} id='save'
            onClick={updateUserData}
          >
            Сохранить
          </div>
        </div>
        <Posts posts={postsForPersonalPage} favorite={true} title="Ваши рецепты" />
      </div>
    </>
  )
}

export default PersonalPage